import { Shield, Crown } from "lucide-react";

export const UserBadges = ({ author }) => (
  <>
    {author.role === "moderator" && (
      <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase px-1.5 py-0.5 rounded bg-[#2EC4B6] text-black" data-testid="badge-moderator">
        <Shield className="w-3 h-3" /> Mod
      </span>
    )}
    {author.is_subscriber && (
      <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase px-1.5 py-0.5 rounded bg-[#FFE500] text-black" data-testid="badge-subscriber">
        <Crown className="w-3 h-3" /> Premium
      </span>
    )}
  </>
);

export const resolveImg = (url) => (url?.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

export const Avatar = ({ author, size = "w-9 h-9" }) =>
  author.picture ? (
    <img src={resolveImg(author.picture)} alt={author.name} referrerPolicy="no-referrer" className={`${size} rounded-full object-cover border-2 border-white/20 flex-shrink-0 bg-black`} />
  ) : (
    <div className={`${size} rounded-full bg-[#E91E8C] flex items-center justify-center font-bold text-white flex-shrink-0`}>
      {author.name?.[0]?.toUpperCase() || "?"}
    </div>
  );

const rtf = new Intl.RelativeTimeFormat("es", { numeric: "auto" });
const UNITS = [["year", 31536000], ["month", 2592000], ["week", 604800], ["day", 86400], ["hour", 3600], ["minute", 60]];

export const timeAgo = (iso) => {
  const diff = (new Date(iso).getTime() - Date.now()) / 1000;
  for (const [unit, secs] of UNITS) {
    if (Math.abs(diff) >= secs) return rtf.format(Math.round(diff / secs), unit);
  }
  return "justo ahora";
};
